// Version of the Terms of Service + Privacy Policy users agree to. Bump it
// (YYYY-MM-DD) whenever the published legal text changes materially: signed-in
// users whose users/{uid}.termsAcceptance.version differs are asked to agree
// again (components/TermsConsentGate.jsx).
export const TERMS_VERSION = '2026-10-27';

export const CONSENT_REQUIRED_ERROR = 'Please confirm you are 21 or older and agree to the Terms and Privacy Policy.';

/** The consent record saved on users/{uid}.termsAcceptance. `acceptedAt` is a server timestamp sentinel. */
export function termsAcceptanceRecord(method, acceptedAt) {
  return { version: TERMS_VERSION, ageConfirmed21: true, method, acceptedAt };
}

/** True when the user has agreed to the current terms version. */
export const hasCurrentConsent = (userDoc) => userDoc?.termsAcceptance?.version === TERMS_VERSION && userDoc?.termsAcceptance?.ageConfirmed21 === true;
